/**
 * OCR結果アコーディオンコンポーネント
 *
 * OCR解析結果の表形式とJSON形式のプレビュー表示
 */

import { Text, Code, Accordion, Box, Table } from "@mantine/core";
import { PlaygroundResult } from "../../services/playgroundService";
import { flattenObject } from "../../utils/jsonUtils";

interface TimelineOcrResultProps {
  ocrResult: NonNullable<PlaygroundResult["ocrResult"]>;
}

export function TimelineOcrResult({ ocrResult }: TimelineOcrResultProps) {
  return (
    <Accordion variant="contained" radius="sm" mt="xs">
      <Accordion.Item value="text">
        <Accordion.Control>
          <Text size="xs" fw={500}>
            解析結果プレビュー（表形式）
          </Text>
        </Accordion.Control>
        <Accordion.Panel>
          <Box style={{ overflowX: "auto" }}>
            <Table striped highlightOnHover withTableBorder>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>フィールド</Table.Th>
                  <Table.Th>値</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {flattenObject(ocrResult.structuredData).map(
                  ({ key, value }) => (
                    <Table.Tr key={key}>
                      <Table.Td>
                        <Text fw={500} size="xs">
                          {key}
                        </Text>
                      </Table.Td>
                      <Table.Td>
                        <Text size="xs" style={{ whiteSpace: "pre-wrap" }}>
                          {value}
                        </Text>
                      </Table.Td>
                    </Table.Tr>
                  )
                )}
              </Table.Tbody>
            </Table>
          </Box>
        </Accordion.Panel>
      </Accordion.Item>
      <Accordion.Item value="structured">
        <Accordion.Control>
          <Text size="xs" fw={500}>
            構造化データ（JSON）
          </Text>
        </Accordion.Control>
        <Accordion.Panel>
          <Code
            block
            style={{
              maxHeight: "200px",
              overflow: "auto",
              fontSize: "11px",
            }}
          >
            {JSON.stringify(ocrResult.structuredData, null, 2)}
          </Code>
        </Accordion.Panel>
      </Accordion.Item>
      {ocrResult.promptUsed && (
        <Accordion.Item value="prompt">
          <Accordion.Control>
            <Text size="xs" fw={500}>
              使用されたプロンプト
            </Text>
          </Accordion.Control>
          <Accordion.Panel>
            <Code
              block
              style={{
                maxHeight: "300px",
                overflow: "auto",
                fontSize: "11px",
                whiteSpace: "pre-wrap",
              }}
            >
              {ocrResult.promptUsed}
            </Code>
          </Accordion.Panel>
        </Accordion.Item>
      )}
    </Accordion>
  );
}
